module.exports = __webpack_public_path__ + "img/period.204855a5.svg";